import { Col, Row } from "antd";
import DaysPicker from "components/Common/DaysPicker";
import VehicleDetails from "components/Dashboard/VehicleDetails";

const VehicleFilter = ({
  // imeiList,
  vehicle,
  onChangeImei,
}) => {
  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={14} md={12} lg={10} xl={7}>
        <VehicleDetails
          onChangeImei={onChangeImei}
          imei={vehicle}
          card={false}
        />
      </Col>
      <Col xs={24} sm={24} md={12} lg={14} xl={17} className="justify-right">
        <DaysPicker localTimeState={false} customOptions={["Day", "Week"]} />
      </Col>
    </Row>
  );
};

export default VehicleFilter;
